import { UPDATE_SEARCHTDATA_DUNOGIAONHANVIEN } from "../../actions/DuNoGiaoNhanVien/actionTypes";

const initialState = {
  pageIndex:1,
  pageSize:20,
  tenNhanVien: "",
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchDuNoGiaoNhanVien = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DUNOGIAONHANVIEN:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDuNoGiaoNhanVien;
